import { Api } from "../api/Api";
export const obLender = () => {
  const getLenderlist = async () => {
    const response = await Api.get("api/v1/get-lender-list", {});
    return response;
  };
  return { getLenderlist };
};